let queryString = typeof window !== 'undefined' ? window.location.search:  ''
const urlParams = new URLSearchParams(queryString)

export default function getUrlVars(key) {
	return urlParams.get(key)	
}